
import { useState } from 'react';
import { Comment } from '../types/comment';
import { Badge } from '@/components/ui/badge';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Textarea } from '@/components/ui/textarea';
import { Button } from '@/components/ui/button';
import { Send, Smile, RefreshCw, Bot, Star, ClipboardList } from 'lucide-react';
import AIGeneratedResponses from './components/AIGeneratedResponses';
import PreparedResponses from './components/PreparedResponses';
import NoteTab from './components/NoteTab';
import ReplyActions from './components/ReplyActions';
import ReplyComposer from './components/ReplyComposer';

interface ReplySectionProps {
  comment: Comment;
}

const ReplySection = ({ comment }: ReplySectionProps) => {
  const [replyContent, setReplyContent] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [activeTab, setActiveTab] = useState('reply');

  const handleReply = async () => {
    if (!replyContent.trim()) return;
    
    setIsSubmitting(true);
    // Simuler un délai d'envoi
    setTimeout(() => {
      console.log('Réponse envoyée:', replyContent);
      setReplyContent('');
      setIsSubmitting(false);
    }, 1000);
  };

  return (
    <div className="border-t border-gray-200 dark:border-gray-700/50 bg-white dark:bg-[#1a1d2d] transition-colors">
      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <div className="px-4 pt-2">
          <TabsList className="grid grid-cols-4 w-full bg-gray-100 dark:bg-gray-800/50">
            <TabsTrigger value="reply" className="data-[state=active]:bg-white dark:data-[state=active]:bg-gray-700">
              <Send className="h-4 w-4 mr-2" />
              Répondre
            </TabsTrigger>
            <TabsTrigger value="ai" className="data-[state=active]:bg-white dark:data-[state=active]:bg-gray-700">
              <Bot className="h-4 w-4 mr-2" />
              IA
            </TabsTrigger>
            <TabsTrigger value="prepared" className="data-[state=active]:bg-white dark:data-[state=active]:bg-gray-700">
              <ClipboardList className="h-4 w-4 mr-2" />
              Réponses
            </TabsTrigger>
            <TabsTrigger value="note" className="data-[state=active]:bg-white dark:data-[state=active]:bg-gray-700">
              <Star className="h-4 w-4 mr-2" />
              Note
            </TabsTrigger>
          </TabsList>
        </div>

        <TabsContent value="reply" className="p-4 space-y-4 mt-0">
          <ReplyComposer 
            replyContent={replyContent} 
            setReplyContent={setReplyContent} 
            isSubmitting={isSubmitting}
            handleReply={handleReply}
            comment={comment}
          />
        </TabsContent>

        <TabsContent value="ai" className="p-4 mt-0">
          <AIGeneratedResponses comment={comment} onSelectResponse={setReplyContent} />
        </TabsContent>

        <TabsContent value="prepared" className="p-4 mt-0">
          <PreparedResponses onSelectResponse={setReplyContent} />
        </TabsContent>

        <TabsContent value="note" className="p-4 mt-0">
          <NoteTab commentId={comment.id} />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default ReplySection;
